import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Company = {
  __typename?: 'Company';
  address?: Maybe<Scalars['String']['output']>;
  as?: Maybe<Scalars['String']['output']>;
  companyInfos?: Maybe<CompanyInfoRelationResponseCollection>;
  companyServices?: Maybe<CompanyServiceRelationResponseCollection>;
  contactNo?: Maybe<Scalars['String']['output']>;
  cover: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  members?: Maybe<MemberCompanyLinkRelationResponseCollection>;
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  regNo?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CompanyCompanyInfosArgs = {
  filters?: InputMaybe<CompanyInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyCompanyServicesArgs = {
  filters?: InputMaybe<CompanyServiceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyMembersArgs = {
  filters?: InputMaybe<MemberCompanyLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CompanyData = {
  __typename?: 'CompanyData';
  address?: Maybe<Scalars['String']['output']>;
  as?: Maybe<Scalars['String']['output']>;
  companyInfos?: Maybe<Array<CompanyInfo>>;
  companyServices?: Maybe<Array<CompanyServiceData>>;
  contactNo?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<UploadFileData>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  regNo?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyEntity = {
  __typename?: 'CompanyEntity';
  attributes?: Maybe<Company>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CompanyEntityResponse = {
  __typename?: 'CompanyEntityResponse';
  data?: Maybe<CompanyEntity>;
};

export type CompanyEntityResponseCollection = {
  __typename?: 'CompanyEntityResponseCollection';
  data: Array<CompanyEntity>;
  meta: ResponseCollectionMeta;
};

export type CompanyFiltersInput = {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<CompanyFiltersInput>>>;
  as?: InputMaybe<StringFilterInput>;
  companyInfos?: InputMaybe<CompanyInfoFiltersInput>;
  companyServices?: InputMaybe<CompanyServiceFiltersInput>;
  contactNo?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  members?: InputMaybe<MemberCompanyLinkFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CompanyFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CompanyFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  regNo?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  company?: Maybe<CompanyEntityResponse>;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  type: Enum_Companyinfo_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyInfoEntity = {
  __typename?: 'CompanyInfoEntity';
  attributes?: Maybe<CompanyInfo>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CompanyInfoEntityResponse = {
  __typename?: 'CompanyInfoEntityResponse';
  data?: Maybe<CompanyInfoEntity>;
};

export type CompanyInfoEntityResponseCollection = {
  __typename?: 'CompanyInfoEntityResponseCollection';
  data: Array<CompanyInfoEntity>;
  meta: ResponseCollectionMeta;
};

export type CompanyInfoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CompanyInfoFiltersInput>>>;
  company?: InputMaybe<CompanyFiltersInput>;
  content?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<CompanyInfoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CompanyInfoFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CompanyInfoInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Enum_Companyinfo_Type>;
};

export type CompanyInfoRelationResponseCollection = {
  __typename?: 'CompanyInfoRelationResponseCollection';
  data: Array<CompanyInfoEntity>;
};

export type CompanyInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  as?: InputMaybe<Scalars['String']['input']>;
  companyInfos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  companyServices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contactNo?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  members?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  regNo?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyRelationResponseCollection = {
  __typename?: 'CompanyRelationResponseCollection';
  data: Array<CompanyEntity>;
};

export type CompanyService = {
  __typename?: 'CompanyService';
  company?: Maybe<CompanyEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  media?: Maybe<UploadFileEntityResponse>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyServiceData = {
  __typename?: 'CompanyServiceData';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<UploadFileData>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyServiceEntity = {
  __typename?: 'CompanyServiceEntity';
  attributes?: Maybe<CompanyService>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CompanyServiceEntityResponse = {
  __typename?: 'CompanyServiceEntityResponse';
  data?: Maybe<CompanyServiceEntity>;
};

export type CompanyServiceEntityResponseCollection = {
  __typename?: 'CompanyServiceEntityResponseCollection';
  data: Array<CompanyServiceEntity>;
  meta: ResponseCollectionMeta;
};

export type CompanyServiceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CompanyServiceFiltersInput>>>;
  company?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CompanyServiceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CompanyServiceFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CompanyServiceInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CompanyServiceRelationResponseCollection = {
  __typename?: 'CompanyServiceRelationResponseCollection';
  data: Array<CompanyServiceEntity>;
};

export type CompanyUserResponse = {
  __typename?: 'CompanyUserResponse';
  company: CompanyData;
  contactNo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  member: MemberData;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum Enum_Companyinfo_Type {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Website = 'WEBSITE'
}

export type Enquiry = {
  __typename?: 'Enquiry';
  company?: Maybe<CompanyEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  enquiry_category?: Maybe<EnquiryCategoryEntityResponse>;
  enquiry_email?: Maybe<Scalars['String']['output']>;
  enquiry_link?: Maybe<Scalars['String']['output']>;
  enquiry_media?: Maybe<UploadFileEntityResponse>;
  enquiry_message?: Maybe<Scalars['String']['output']>;
  enquiry_mobile?: Maybe<Scalars['String']['output']>;
  enquiry_name?: Maybe<Scalars['String']['output']>;
  post?: Maybe<PostEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EnquiryCategory = {
  __typename?: 'EnquiryCategory';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  enquiry_category_name: Scalars['String']['output'];
  enquiry_category_slug: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EnquiryCategoryEntity = {
  __typename?: 'EnquiryCategoryEntity';
  attributes?: Maybe<EnquiryCategory>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EnquiryCategoryEntityResponse = {
  __typename?: 'EnquiryCategoryEntityResponse';
  data?: Maybe<EnquiryCategoryEntity>;
};

export type EnquiryCategoryEntityResponseCollection = {
  __typename?: 'EnquiryCategoryEntityResponseCollection';
  data: Array<EnquiryCategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type EnquiryCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EnquiryCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  enquiry_category_name?: InputMaybe<StringFilterInput>;
  enquiry_category_slug?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<EnquiryCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EnquiryCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EnquiryCategoryInput = {
  enquiry_category_name?: InputMaybe<Scalars['String']['input']>;
  enquiry_category_slug?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EnquiryEntity = {
  __typename?: 'EnquiryEntity';
  attributes?: Maybe<Enquiry>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EnquiryEntityResponse = {
  __typename?: 'EnquiryEntityResponse';
  data?: Maybe<EnquiryEntity>;
};

export type EnquiryEntityResponseCollection = {
  __typename?: 'EnquiryEntityResponseCollection';
  data: Array<EnquiryEntity>;
  meta: ResponseCollectionMeta;
};

export type EnquiryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EnquiryFiltersInput>>>;
  company?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  enquiry_category?: InputMaybe<EnquiryCategoryFiltersInput>;
  enquiry_email?: InputMaybe<StringFilterInput>;
  enquiry_link?: InputMaybe<StringFilterInput>;
  enquiry_message?: InputMaybe<StringFilterInput>;
  enquiry_mobile?: InputMaybe<StringFilterInput>;
  enquiry_name?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<EnquiryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EnquiryFiltersInput>>>;
  post?: InputMaybe<PostFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EnquiryInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  enquiry_category?: InputMaybe<Scalars['ID']['input']>;
  enquiry_email?: InputMaybe<Scalars['String']['input']>;
  enquiry_link?: InputMaybe<Scalars['String']['input']>;
  enquiry_media?: InputMaybe<Scalars['ID']['input']>;
  enquiry_message?: InputMaybe<Scalars['String']['input']>;
  enquiry_mobile?: InputMaybe<Scalars['String']['input']>;
  enquiry_name?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type GenericMorph = Company | CompanyInfo | CompanyService | Enquiry | EnquiryCategory | I18NLocale | Member | MemberCompanyLink | Post | PostCategory | PostTag | PostType | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type Member = {
  __typename?: 'Member';
  avatar?: Maybe<UploadFileEntityResponse>;
  contactNo: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  facebookLink?: Maybe<Scalars['String']['output']>;
  linkedinLink?: Maybe<Scalars['String']['output']>;
  links?: Maybe<MemberCompanyLinkRelationResponseCollection>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MemberLinksArgs = {
  filters?: InputMaybe<MemberCompanyLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MemberCompanyLink = {
  __typename?: 'MemberCompanyLink';
  company?: Maybe<CompanyEntityResponse>;
  contactNo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  member?: Maybe<MemberEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MemberCompanyLinkEntity = {
  __typename?: 'MemberCompanyLinkEntity';
  attributes?: Maybe<MemberCompanyLink>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MemberCompanyLinkEntityResponse = {
  __typename?: 'MemberCompanyLinkEntityResponse';
  data?: Maybe<MemberCompanyLinkEntity>;
};

export type MemberCompanyLinkEntityResponseCollection = {
  __typename?: 'MemberCompanyLinkEntityResponseCollection';
  data: Array<MemberCompanyLinkEntity>;
  meta: ResponseCollectionMeta;
};

export type MemberCompanyLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MemberCompanyLinkFiltersInput>>>;
  company?: InputMaybe<CompanyFiltersInput>;
  contactNo?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  member?: InputMaybe<MemberFiltersInput>;
  not?: InputMaybe<MemberCompanyLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MemberCompanyLinkFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MemberCompanyLinkInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  contactNo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  member?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MemberCompanyLinkRelationResponseCollection = {
  __typename?: 'MemberCompanyLinkRelationResponseCollection';
  data: Array<MemberCompanyLinkEntity>;
};

export type MemberData = {
  __typename?: 'MemberData';
  avatar?: Maybe<UploadFileData>;
  contactNo: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkedinLink?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MemberEntity = {
  __typename?: 'MemberEntity';
  attributes?: Maybe<Member>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MemberEntityResponse = {
  __typename?: 'MemberEntityResponse';
  data?: Maybe<MemberEntity>;
};

export type MemberEntityResponseCollection = {
  __typename?: 'MemberEntityResponseCollection';
  data: Array<MemberEntity>;
  meta: ResponseCollectionMeta;
};

export type MemberFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MemberFiltersInput>>>;
  contactNo?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  facebookLink?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  linkedinLink?: InputMaybe<StringFilterInput>;
  links?: InputMaybe<MemberCompanyLinkFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MemberFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MemberFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MemberInput = {
  avatar?: InputMaybe<Scalars['ID']['input']>;
  contactNo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  linkedinLink?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createCompany?: Maybe<CompanyEntityResponse>;
  createCompanyInfo?: Maybe<CompanyInfoEntityResponse>;
  createCompanyService?: Maybe<CompanyServiceEntityResponse>;
  createEnquiry?: Maybe<EnquiryEntityResponse>;
  createEnquiryCategory?: Maybe<EnquiryCategoryEntityResponse>;
  createMember?: Maybe<MemberEntityResponse>;
  createMemberCompanyLink?: Maybe<MemberCompanyLinkEntityResponse>;
  createPost?: Maybe<PostEntityResponse>;
  createPostCategory?: Maybe<PostCategoryEntityResponse>;
  createPostTag?: Maybe<PostTagEntityResponse>;
  createPostType?: Maybe<PostTypeEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteCompany?: Maybe<CompanyEntityResponse>;
  deleteCompanyInfo?: Maybe<CompanyInfoEntityResponse>;
  deleteCompanyService?: Maybe<CompanyServiceEntityResponse>;
  deleteEnquiry?: Maybe<EnquiryEntityResponse>;
  deleteEnquiryCategory?: Maybe<EnquiryCategoryEntityResponse>;
  deleteMember?: Maybe<MemberEntityResponse>;
  deleteMemberCompanyLink?: Maybe<MemberCompanyLinkEntityResponse>;
  deletePost?: Maybe<PostEntityResponse>;
  deletePostCategory?: Maybe<PostCategoryEntityResponse>;
  deletePostTag?: Maybe<PostTagEntityResponse>;
  deletePostType?: Maybe<PostTypeEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateCompany?: Maybe<CompanyEntityResponse>;
  updateCompanyInfo?: Maybe<CompanyInfoEntityResponse>;
  updateCompanyService?: Maybe<CompanyServiceEntityResponse>;
  updateEnquiry?: Maybe<EnquiryEntityResponse>;
  updateEnquiryCategory?: Maybe<EnquiryCategoryEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateMember?: Maybe<MemberEntityResponse>;
  updateMemberCompanyLink?: Maybe<MemberCompanyLinkEntityResponse>;
  updatePost?: Maybe<PostEntityResponse>;
  updatePostCategory?: Maybe<PostCategoryEntityResponse>;
  updatePostTag?: Maybe<PostTagEntityResponse>;
  updatePostType?: Maybe<PostTypeEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  upload: UploadFileEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateCompanyArgs = {
  data: CompanyInput;
};


export type MutationCreateCompanyInfoArgs = {
  data: CompanyInfoInput;
};


export type MutationCreateCompanyServiceArgs = {
  data: CompanyServiceInput;
};


export type MutationCreateEnquiryArgs = {
  data: EnquiryInput;
};


export type MutationCreateEnquiryCategoryArgs = {
  data: EnquiryCategoryInput;
};


export type MutationCreateMemberArgs = {
  data: MemberInput;
};


export type MutationCreateMemberCompanyLinkArgs = {
  data: MemberCompanyLinkInput;
};


export type MutationCreatePostArgs = {
  data: PostInput;
};


export type MutationCreatePostCategoryArgs = {
  data: PostCategoryInput;
};


export type MutationCreatePostTagArgs = {
  data: PostTagInput;
};


export type MutationCreatePostTypeArgs = {
  data: PostTypeInput;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompanyInfoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompanyServiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEnquiryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEnquiryCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMemberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMemberCompanyLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePostCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePostTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePostTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUpdateCompanyArgs = {
  data: CompanyInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCompanyInfoArgs = {
  data: CompanyInfoInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCompanyServiceArgs = {
  data: CompanyServiceInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateEnquiryArgs = {
  data: EnquiryInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateEnquiryCategoryArgs = {
  data: EnquiryCategoryInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateMemberArgs = {
  data: MemberInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateMemberCompanyLinkArgs = {
  data: MemberCompanyLinkInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePostArgs = {
  data: PostInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePostCategoryArgs = {
  data: PostCategoryInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePostTagArgs = {
  data: PostTagInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePostTypeArgs = {
  data: PostTypeInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type Post = {
  __typename?: 'Post';
  companies?: Maybe<CompanyRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  post_categories?: Maybe<PostCategoryRelationResponseCollection>;
  post_description?: Maybe<Scalars['String']['output']>;
  post_priority?: Maybe<Scalars['Int']['output']>;
  post_short_description?: Maybe<Scalars['String']['output']>;
  post_slug: Scalars['String']['output'];
  post_tags?: Maybe<PostTagRelationResponseCollection>;
  post_thumb?: Maybe<UploadFileEntityResponse>;
  post_thumb_img_alt?: Maybe<Scalars['String']['output']>;
  post_title: Scalars['String']['output'];
  post_title_2?: Maybe<Scalars['String']['output']>;
  post_type?: Maybe<PostTypeEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type PostCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PostPost_CategoriesArgs = {
  filters?: InputMaybe<PostCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PostPost_TagsArgs = {
  filters?: InputMaybe<PostTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PostCategory = {
  __typename?: 'PostCategory';
  companies?: Maybe<CompanyRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  post_category_description?: Maybe<Scalars['String']['output']>;
  post_category_name: Scalars['String']['output'];
  post_category_slug: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type PostCategoryCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PostCategoryEntity = {
  __typename?: 'PostCategoryEntity';
  attributes?: Maybe<PostCategory>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PostCategoryEntityResponse = {
  __typename?: 'PostCategoryEntityResponse';
  data?: Maybe<PostCategoryEntity>;
};

export type PostCategoryEntityResponseCollection = {
  __typename?: 'PostCategoryEntityResponseCollection';
  data: Array<PostCategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type PostCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PostCategoryFiltersInput>>>;
  companies?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PostCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PostCategoryFiltersInput>>>;
  post_category_description?: InputMaybe<StringFilterInput>;
  post_category_name?: InputMaybe<StringFilterInput>;
  post_category_slug?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PostCategoryInput = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  post_category_description?: InputMaybe<Scalars['String']['input']>;
  post_category_name?: InputMaybe<Scalars['String']['input']>;
  post_category_slug?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostCategoryRelationResponseCollection = {
  __typename?: 'PostCategoryRelationResponseCollection';
  data: Array<PostCategoryEntity>;
};

export type PostEntity = {
  __typename?: 'PostEntity';
  attributes?: Maybe<Post>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PostEntityResponse = {
  __typename?: 'PostEntityResponse';
  data?: Maybe<PostEntity>;
};

export type PostEntityResponseCollection = {
  __typename?: 'PostEntityResponseCollection';
  data: Array<PostEntity>;
  meta: ResponseCollectionMeta;
};

export type PostFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PostFiltersInput>>>;
  companies?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PostFiltersInput>>>;
  post_categories?: InputMaybe<PostCategoryFiltersInput>;
  post_description?: InputMaybe<StringFilterInput>;
  post_priority?: InputMaybe<IntFilterInput>;
  post_short_description?: InputMaybe<StringFilterInput>;
  post_slug?: InputMaybe<StringFilterInput>;
  post_tags?: InputMaybe<PostTagFiltersInput>;
  post_thumb_img_alt?: InputMaybe<StringFilterInput>;
  post_title?: InputMaybe<StringFilterInput>;
  post_title_2?: InputMaybe<StringFilterInput>;
  post_type?: InputMaybe<PostTypeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PostInput = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  post_categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  post_description?: InputMaybe<Scalars['String']['input']>;
  post_priority?: InputMaybe<Scalars['Int']['input']>;
  post_short_description?: InputMaybe<Scalars['String']['input']>;
  post_slug?: InputMaybe<Scalars['String']['input']>;
  post_tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  post_thumb?: InputMaybe<Scalars['ID']['input']>;
  post_thumb_img_alt?: InputMaybe<Scalars['String']['input']>;
  post_title?: InputMaybe<Scalars['String']['input']>;
  post_title_2?: InputMaybe<Scalars['String']['input']>;
  post_type?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostTag = {
  __typename?: 'PostTag';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  post_tag_name: Scalars['String']['output'];
  post_tag_slug?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PostTagEntity = {
  __typename?: 'PostTagEntity';
  attributes?: Maybe<PostTag>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PostTagEntityResponse = {
  __typename?: 'PostTagEntityResponse';
  data?: Maybe<PostTagEntity>;
};

export type PostTagEntityResponseCollection = {
  __typename?: 'PostTagEntityResponseCollection';
  data: Array<PostTagEntity>;
  meta: ResponseCollectionMeta;
};

export type PostTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PostTagFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PostTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PostTagFiltersInput>>>;
  post_tag_name?: InputMaybe<StringFilterInput>;
  post_tag_slug?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PostTagInput = {
  post_tag_name?: InputMaybe<Scalars['String']['input']>;
  post_tag_slug?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostTagRelationResponseCollection = {
  __typename?: 'PostTagRelationResponseCollection';
  data: Array<PostTagEntity>;
};

export type PostType = {
  __typename?: 'PostType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  post_type_name: Scalars['String']['output'];
  post_type_slug: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PostTypeEntity = {
  __typename?: 'PostTypeEntity';
  attributes?: Maybe<PostType>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PostTypeEntityResponse = {
  __typename?: 'PostTypeEntityResponse';
  data?: Maybe<PostTypeEntity>;
};

export type PostTypeEntityResponseCollection = {
  __typename?: 'PostTypeEntityResponseCollection';
  data: Array<PostTypeEntity>;
  meta: ResponseCollectionMeta;
};

export type PostTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PostTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PostTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PostTypeFiltersInput>>>;
  post_type_name?: InputMaybe<StringFilterInput>;
  post_type_slug?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PostTypeInput = {
  post_type_name?: InputMaybe<Scalars['String']['input']>;
  post_type_slug?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  companies?: Maybe<CompanyEntityResponseCollection>;
  company?: Maybe<CompanyEntityResponse>;
  companyInfo?: Maybe<CompanyInfoEntityResponse>;
  companyInfos?: Maybe<CompanyInfoEntityResponseCollection>;
  companyMember?: Maybe<CompanyUserResponse>;
  companyService?: Maybe<CompanyServiceEntityResponse>;
  companyServices?: Maybe<CompanyServiceEntityResponseCollection>;
  enquiries?: Maybe<EnquiryEntityResponseCollection>;
  enquiry?: Maybe<EnquiryEntityResponse>;
  enquiryCategories?: Maybe<EnquiryCategoryEntityResponseCollection>;
  enquiryCategory?: Maybe<EnquiryCategoryEntityResponse>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  member?: Maybe<MemberEntityResponse>;
  memberCompanyLink?: Maybe<MemberCompanyLinkEntityResponse>;
  memberCompanyLinks?: Maybe<MemberCompanyLinkEntityResponseCollection>;
  members?: Maybe<MemberEntityResponseCollection>;
  post?: Maybe<PostEntityResponse>;
  postCategories?: Maybe<PostCategoryEntityResponseCollection>;
  postCategory?: Maybe<PostCategoryEntityResponse>;
  postTag?: Maybe<PostTagEntityResponse>;
  postTags?: Maybe<PostTagEntityResponseCollection>;
  postType?: Maybe<PostTypeEntityResponse>;
  postTypes?: Maybe<PostTypeEntityResponseCollection>;
  posts?: Maybe<PostEntityResponseCollection>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};


export type QueryCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCompanyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCompanyInfoArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCompanyInfosArgs = {
  filters?: InputMaybe<CompanyInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCompanyMemberArgs = {
  company: Scalars['String']['input'];
  user: Scalars['String']['input'];
};


export type QueryCompanyServiceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCompanyServicesArgs = {
  filters?: InputMaybe<CompanyServiceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEnquiriesArgs = {
  filters?: InputMaybe<EnquiryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEnquiryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEnquiryCategoriesArgs = {
  filters?: InputMaybe<EnquiryCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEnquiryCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMemberArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMemberCompanyLinkArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMemberCompanyLinksArgs = {
  filters?: InputMaybe<MemberCompanyLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMembersArgs = {
  filters?: InputMaybe<MemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPostArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPostCategoriesArgs = {
  filters?: InputMaybe<PostCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPostCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPostTagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPostTagsArgs = {
  filters?: InputMaybe<PostTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPostTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPostTypesArgs = {
  filters?: InputMaybe<PostTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPostsArgs = {
  filters?: InputMaybe<PostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileData = {
  __typename?: 'UploadFileData';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String']['output'];
  pathId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type CompanyLessDetailFragment = { __typename?: 'Company', name?: string | null, regNo?: string | null, slug: string, address?: string | null, contactNo?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } };

export type EnquiryCategoryDetailFragment = { __typename?: 'EnquiryCategory', enquiry_category_name: string, enquiry_category_slug: string };

export type PostLessDetailFragment = { __typename?: 'Post', post_title: string, post_title_2?: string | null, post_short_description?: string | null, post_description?: string | null, post_slug: string, post_thumb_img_alt?: string | null, post_priority?: number | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, post_thumb?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } | null, post_categories?: { __typename?: 'PostCategoryRelationResponseCollection', data: Array<{ __typename?: 'PostCategoryEntity', id?: string | null, attributes?: { __typename?: 'PostCategory', post_category_name: string, post_category_description?: string | null, post_category_slug: string } | null }> } | null, post_tags?: { __typename?: 'PostTagRelationResponseCollection', data: Array<{ __typename?: 'PostTagEntity', id?: string | null, attributes?: { __typename?: 'PostTag', post_tag_name: string, post_tag_slug?: string | null } | null }> } | null };

export type PostDetailFragment = { __typename?: 'Post', post_title: string, post_title_2?: string | null, post_short_description?: string | null, post_description?: string | null, post_slug: string, post_thumb_img_alt?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, post_thumb?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } | null, post_categories?: { __typename?: 'PostCategoryRelationResponseCollection', data: Array<{ __typename?: 'PostCategoryEntity', id?: string | null, attributes?: { __typename?: 'PostCategory', post_category_name: string, post_category_description?: string | null, post_category_slug: string } | null }> } | null, post_tags?: { __typename?: 'PostTagRelationResponseCollection', data: Array<{ __typename?: 'PostTagEntity', id?: string | null, attributes?: { __typename?: 'PostTag', post_tag_name: string, post_tag_slug?: string | null } | null }> } | null };

export type EnquiryDetailFragment = { __typename?: 'Enquiry', enquiry_name?: string | null, enquiry_email?: string | null, enquiry_mobile?: string | null, enquiry_message?: string | null, enquiry_category?: { __typename?: 'EnquiryCategoryEntityResponse', data?: { __typename?: 'EnquiryCategoryEntity', id?: string | null, attributes?: { __typename?: 'EnquiryCategory', enquiry_category_name: string, enquiry_category_slug: string } | null } | null } | null, post?: { __typename?: 'PostEntityResponse', data?: { __typename?: 'PostEntity', id?: string | null, attributes?: { __typename?: 'Post', post_title: string, post_title_2?: string | null, post_short_description?: string | null, post_description?: string | null, post_slug: string, post_thumb_img_alt?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, post_thumb?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } | null, post_categories?: { __typename?: 'PostCategoryRelationResponseCollection', data: Array<{ __typename?: 'PostCategoryEntity', id?: string | null, attributes?: { __typename?: 'PostCategory', post_category_name: string, post_category_description?: string | null, post_category_slug: string } | null }> } | null, post_tags?: { __typename?: 'PostTagRelationResponseCollection', data: Array<{ __typename?: 'PostTagEntity', id?: string | null, attributes?: { __typename?: 'PostTag', post_tag_name: string, post_tag_slug?: string | null } | null }> } | null } | null } | null } | null, company?: { __typename?: 'CompanyEntityResponse', data?: { __typename?: 'CompanyEntity', id?: string | null, attributes?: { __typename?: 'Company', name?: string | null, regNo?: string | null, slug: string, address?: string | null, contactNo?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } } | null } | null } | null, enquiry_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } | null };

export type CompanyLessDetailRelationFragment = { __typename?: 'CompanyEntityResponse', data?: { __typename?: 'CompanyEntity', id?: string | null, attributes?: { __typename?: 'Company', name?: string | null, regNo?: string | null, slug: string, address?: string | null, contactNo?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } } | null } | null };

export type EnquiryCategoryRelationFragment = { __typename?: 'EnquiryCategoryEntityResponse', data?: { __typename?: 'EnquiryCategoryEntity', id?: string | null, attributes?: { __typename?: 'EnquiryCategory', enquiry_category_name: string, enquiry_category_slug: string } | null } | null };

export type PostRelationFragment = { __typename?: 'PostEntityResponse', data?: { __typename?: 'PostEntity', id?: string | null, attributes?: { __typename?: 'Post', post_title: string, post_title_2?: string | null, post_short_description?: string | null, post_description?: string | null, post_slug: string, post_thumb_img_alt?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, post_thumb?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } | null, post_categories?: { __typename?: 'PostCategoryRelationResponseCollection', data: Array<{ __typename?: 'PostCategoryEntity', id?: string | null, attributes?: { __typename?: 'PostCategory', post_category_name: string, post_category_description?: string | null, post_category_slug: string } | null }> } | null, post_tags?: { __typename?: 'PostTagRelationResponseCollection', data: Array<{ __typename?: 'PostTagEntity', id?: string | null, attributes?: { __typename?: 'PostTag', post_tag_name: string, post_tag_slug?: string | null } | null }> } | null } | null } | null };

export type PostCategoriesRelationFragment = { __typename?: 'PostCategoryRelationResponseCollection', data: Array<{ __typename?: 'PostCategoryEntity', id?: string | null, attributes?: { __typename?: 'PostCategory', post_category_name: string, post_category_description?: string | null, post_category_slug: string } | null }> };

export type PostTagsRelationFragment = { __typename?: 'PostTagRelationResponseCollection', data: Array<{ __typename?: 'PostTagEntity', id?: string | null, attributes?: { __typename?: 'PostTag', post_tag_name: string, post_tag_slug?: string | null } | null }> };

export type UploadFileRelationFragment = { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null };

export type PostCategoriesFragment = { __typename?: 'PostCategory', post_category_name: string, post_category_description?: string | null, post_category_slug: string };

export type PostTagsFragment = { __typename?: 'PostTag', post_tag_name: string, post_tag_slug?: string | null };

export type UploadFileFragment = { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null };

export type PaginationMetaFragment = { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number } };

export type PaginationFragment = { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number };

export type CreateEnquiryMutationVariables = Exact<{
  data: EnquiryInput;
}>;


export type CreateEnquiryMutation = { __typename?: 'Mutation', createEnquiry?: { __typename?: 'EnquiryEntityResponse', data?: { __typename?: 'EnquiryEntity', id?: string | null, attributes?: { __typename?: 'Enquiry', enquiry_name?: string | null, enquiry_email?: string | null, enquiry_mobile?: string | null, enquiry_message?: string | null, enquiry_category?: { __typename?: 'EnquiryCategoryEntityResponse', data?: { __typename?: 'EnquiryCategoryEntity', id?: string | null, attributes?: { __typename?: 'EnquiryCategory', enquiry_category_name: string, enquiry_category_slug: string } | null } | null } | null, post?: { __typename?: 'PostEntityResponse', data?: { __typename?: 'PostEntity', id?: string | null, attributes?: { __typename?: 'Post', post_title: string, post_title_2?: string | null, post_short_description?: string | null, post_description?: string | null, post_slug: string, post_thumb_img_alt?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, post_thumb?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } | null, post_categories?: { __typename?: 'PostCategoryRelationResponseCollection', data: Array<{ __typename?: 'PostCategoryEntity', id?: string | null, attributes?: { __typename?: 'PostCategory', post_category_name: string, post_category_description?: string | null, post_category_slug: string } | null }> } | null, post_tags?: { __typename?: 'PostTagRelationResponseCollection', data: Array<{ __typename?: 'PostTagEntity', id?: string | null, attributes?: { __typename?: 'PostTag', post_tag_name: string, post_tag_slug?: string | null } | null }> } | null } | null } | null } | null, company?: { __typename?: 'CompanyEntityResponse', data?: { __typename?: 'CompanyEntity', id?: string | null, attributes?: { __typename?: 'Company', name?: string | null, regNo?: string | null, slug: string, address?: string | null, contactNo?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } } | null } | null } | null, enquiry_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } | null } | null } | null } | null };

export type UploadMediaMutationVariables = Exact<{
  refId?: InputMaybe<Scalars['ID']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  info?: InputMaybe<FileInfoInput>;
  file: Scalars['Upload']['input'];
}>;


export type UploadMediaMutation = { __typename?: 'Mutation', upload: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } };

export type CompanyListingQueryVariables = Exact<{
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type CompanyListingQuery = { __typename?: 'Query', companies?: { __typename?: 'CompanyEntityResponseCollection', data: Array<{ __typename?: 'CompanyEntity', id?: string | null, attributes?: { __typename?: 'Company', name?: string | null, regNo?: string | null, slug: string, address?: string | null, contactNo?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number } } } | null };

export type EnquiryCategoryListingQueryVariables = Exact<{
  filters?: InputMaybe<EnquiryCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type EnquiryCategoryListingQuery = { __typename?: 'Query', enquiryCategories?: { __typename?: 'EnquiryCategoryEntityResponseCollection', data: Array<{ __typename?: 'EnquiryCategoryEntity', id?: string | null, attributes?: { __typename?: 'EnquiryCategory', enquiry_category_name: string, enquiry_category_slug: string } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number } } } | null };

export type PostListingQueryVariables = Exact<{
  filters?: InputMaybe<PostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type PostListingQuery = { __typename?: 'Query', posts?: { __typename?: 'PostEntityResponseCollection', data: Array<{ __typename?: 'PostEntity', id?: string | null, attributes?: { __typename?: 'Post', post_title: string, post_title_2?: string | null, post_short_description?: string | null, post_description?: string | null, post_slug: string, post_thumb_img_alt?: string | null, post_priority?: number | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, post_thumb?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } | null, post_categories?: { __typename?: 'PostCategoryRelationResponseCollection', data: Array<{ __typename?: 'PostCategoryEntity', id?: string | null, attributes?: { __typename?: 'PostCategory', post_category_name: string, post_category_description?: string | null, post_category_slug: string } | null }> } | null, post_tags?: { __typename?: 'PostTagRelationResponseCollection', data: Array<{ __typename?: 'PostTagEntity', id?: string | null, attributes?: { __typename?: 'PostTag', post_tag_name: string, post_tag_slug?: string | null } | null }> } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number } } } | null };

export type PostDetailQueryVariables = Exact<{
  post_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PostDetailQuery = { __typename?: 'Query', post?: { __typename?: 'PostEntityResponse', data?: { __typename?: 'PostEntity', id?: string | null, attributes?: { __typename?: 'Post', post_title: string, post_title_2?: string | null, post_short_description?: string | null, post_description?: string | null, post_slug: string, post_thumb_img_alt?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, post_thumb?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, size: number, url: string, provider_metadata?: any | null, createdAt?: any | null } | null } | null } | null, post_categories?: { __typename?: 'PostCategoryRelationResponseCollection', data: Array<{ __typename?: 'PostCategoryEntity', id?: string | null, attributes?: { __typename?: 'PostCategory', post_category_name: string, post_category_description?: string | null, post_category_slug: string } | null }> } | null, post_tags?: { __typename?: 'PostTagRelationResponseCollection', data: Array<{ __typename?: 'PostTagEntity', id?: string | null, attributes?: { __typename?: 'PostTag', post_tag_name: string, post_tag_slug?: string | null } | null }> } | null } | null } | null } | null };

export type PostCategoryListingQueryVariables = Exact<{
  filters?: InputMaybe<PostCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type PostCategoryListingQuery = { __typename?: 'Query', postCategories?: { __typename?: 'PostCategoryEntityResponseCollection', data: Array<{ __typename?: 'PostCategoryEntity', id?: string | null, attributes?: { __typename?: 'PostCategory', post_category_name: string, post_category_description?: string | null, post_category_slug: string } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number } } } | null };

export type PostTagListingQueryVariables = Exact<{
  filters?: InputMaybe<PostTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type PostTagListingQuery = { __typename?: 'Query', postTags?: { __typename?: 'PostTagEntityResponseCollection', data: Array<{ __typename?: 'PostTagEntity', id?: string | null, attributes?: { __typename?: 'PostTag', post_tag_name: string, post_tag_slug?: string | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number } } } | null };

export const UploadFileFragmentDoc = gql`
    fragment UploadFile on UploadFile {
  name
  alternativeText
  caption
  width
  height
  formats
  size
  url
  provider_metadata
  createdAt
}
    `;
export const UploadFileRelationFragmentDoc = gql`
    fragment UploadFileRelation on UploadFileEntityResponse {
  data {
    id
    attributes {
      ...UploadFile
    }
  }
}
    ${UploadFileFragmentDoc}`;
export const PostCategoriesFragmentDoc = gql`
    fragment PostCategories on PostCategory {
  post_category_name
  post_category_description
  post_category_slug
}
    `;
export const PostCategoriesRelationFragmentDoc = gql`
    fragment PostCategoriesRelation on PostCategoryRelationResponseCollection {
  data {
    id
    attributes {
      ...PostCategories
    }
  }
}
    ${PostCategoriesFragmentDoc}`;
export const PostTagsFragmentDoc = gql`
    fragment PostTags on PostTag {
  post_tag_name
  post_tag_slug
}
    `;
export const PostTagsRelationFragmentDoc = gql`
    fragment PostTagsRelation on PostTagRelationResponseCollection {
  data {
    id
    attributes {
      ...PostTags
    }
  }
}
    ${PostTagsFragmentDoc}`;
export const PostLessDetailFragmentDoc = gql`
    fragment PostLessDetail on Post {
  post_title
  post_title_2
  post_short_description
  post_description
  post_slug
  post_thumb {
    ...UploadFileRelation
  }
  post_categories {
    ...PostCategoriesRelation
  }
  post_tags {
    ...PostTagsRelation
  }
  post_thumb_img_alt
  post_priority
  createdAt
  updatedAt
  publishedAt
}
    ${UploadFileRelationFragmentDoc}
${PostCategoriesRelationFragmentDoc}
${PostTagsRelationFragmentDoc}`;
export const EnquiryCategoryDetailFragmentDoc = gql`
    fragment EnquiryCategoryDetail on EnquiryCategory {
  enquiry_category_name
  enquiry_category_slug
}
    `;
export const EnquiryCategoryRelationFragmentDoc = gql`
    fragment EnquiryCategoryRelation on EnquiryCategoryEntityResponse {
  data {
    id
    attributes {
      ...EnquiryCategoryDetail
    }
  }
}
    ${EnquiryCategoryDetailFragmentDoc}`;
export const PostDetailFragmentDoc = gql`
    fragment PostDetail on Post {
  post_title
  post_title_2
  post_short_description
  post_description
  post_slug
  post_thumb_img_alt
  post_thumb {
    ...UploadFileRelation
  }
  post_categories {
    ...PostCategoriesRelation
  }
  post_tags {
    ...PostTagsRelation
  }
  createdAt
  updatedAt
  publishedAt
}
    ${UploadFileRelationFragmentDoc}
${PostCategoriesRelationFragmentDoc}
${PostTagsRelationFragmentDoc}`;
export const PostRelationFragmentDoc = gql`
    fragment PostRelation on PostEntityResponse {
  data {
    id
    attributes {
      ...PostDetail
    }
  }
}
    ${PostDetailFragmentDoc}`;
export const CompanyLessDetailFragmentDoc = gql`
    fragment CompanyLessDetail on Company {
  name
  regNo
  slug
  cover {
    ...UploadFileRelation
  }
  address
  contactNo
}
    ${UploadFileRelationFragmentDoc}`;
export const CompanyLessDetailRelationFragmentDoc = gql`
    fragment CompanyLessDetailRelation on CompanyEntityResponse {
  data {
    id
    attributes {
      ...CompanyLessDetail
    }
  }
}
    ${CompanyLessDetailFragmentDoc}`;
export const EnquiryDetailFragmentDoc = gql`
    fragment EnquiryDetail on Enquiry {
  enquiry_name
  enquiry_email
  enquiry_mobile
  enquiry_message
  enquiry_category {
    ...EnquiryCategoryRelation
  }
  post {
    ...PostRelation
  }
  company {
    ...CompanyLessDetailRelation
  }
  enquiry_media {
    ...UploadFileRelation
  }
}
    ${EnquiryCategoryRelationFragmentDoc}
${PostRelationFragmentDoc}
${CompanyLessDetailRelationFragmentDoc}
${UploadFileRelationFragmentDoc}`;
export const PaginationFragmentDoc = gql`
    fragment Pagination on Pagination {
  total
  page
  pageSize
  pageCount
}
    `;
export const PaginationMetaFragmentDoc = gql`
    fragment PaginationMeta on ResponseCollectionMeta {
  pagination {
    ...Pagination
  }
}
    ${PaginationFragmentDoc}`;
export const CreateEnquiryDocument = gql`
    mutation createEnquiry($data: EnquiryInput!) {
  createEnquiry(data: $data) {
    data {
      id
      attributes {
        ...EnquiryDetail
      }
    }
  }
}
    ${EnquiryDetailFragmentDoc}`;
export type CreateEnquiryMutationFn = Apollo.MutationFunction<CreateEnquiryMutation, CreateEnquiryMutationVariables>;

/**
 * __useCreateEnquiryMutation__
 *
 * To run a mutation, you first call `useCreateEnquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnquiryMutation, { data, loading, error }] = useCreateEnquiryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEnquiryMutation(baseOptions?: Apollo.MutationHookOptions<CreateEnquiryMutation, CreateEnquiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEnquiryMutation, CreateEnquiryMutationVariables>(CreateEnquiryDocument, options);
      }
export type CreateEnquiryMutationHookResult = ReturnType<typeof useCreateEnquiryMutation>;
export type CreateEnquiryMutationResult = Apollo.MutationResult<CreateEnquiryMutation>;
export type CreateEnquiryMutationOptions = Apollo.BaseMutationOptions<CreateEnquiryMutation, CreateEnquiryMutationVariables>;
export const UploadMediaDocument = gql`
    mutation uploadMedia($refId: ID, $ref: String, $field: String, $info: FileInfoInput, $file: Upload!) {
  upload(refId: $refId, ref: $ref, field: $field, info: $info, file: $file) {
    data {
      id
      attributes {
        ...UploadFile
      }
    }
  }
}
    ${UploadFileFragmentDoc}`;
export type UploadMediaMutationFn = Apollo.MutationFunction<UploadMediaMutation, UploadMediaMutationVariables>;

/**
 * __useUploadMediaMutation__
 *
 * To run a mutation, you first call `useUploadMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMediaMutation, { data, loading, error }] = useUploadMediaMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      ref: // value for 'ref'
 *      field: // value for 'field'
 *      info: // value for 'info'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadMediaMutation(baseOptions?: Apollo.MutationHookOptions<UploadMediaMutation, UploadMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMediaMutation, UploadMediaMutationVariables>(UploadMediaDocument, options);
      }
export type UploadMediaMutationHookResult = ReturnType<typeof useUploadMediaMutation>;
export type UploadMediaMutationResult = Apollo.MutationResult<UploadMediaMutation>;
export type UploadMediaMutationOptions = Apollo.BaseMutationOptions<UploadMediaMutation, UploadMediaMutationVariables>;
export const CompanyListingDocument = gql`
    query companyListing($filters: CompanyFiltersInput, $pagination: PaginationArg, $sort: [String], $publicationState: PublicationState) {
  companies(
    filters: $filters
    pagination: $pagination
    sort: $sort
    publicationState: $publicationState
  ) {
    data {
      id
      attributes {
        ...CompanyLessDetail
      }
    }
    meta {
      ...PaginationMeta
    }
  }
}
    ${CompanyLessDetailFragmentDoc}
${PaginationMetaFragmentDoc}`;

/**
 * __useCompanyListingQuery__
 *
 * To run a query within a React component, call `useCompanyListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyListingQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function useCompanyListingQuery(baseOptions?: Apollo.QueryHookOptions<CompanyListingQuery, CompanyListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyListingQuery, CompanyListingQueryVariables>(CompanyListingDocument, options);
      }
export function useCompanyListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyListingQuery, CompanyListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyListingQuery, CompanyListingQueryVariables>(CompanyListingDocument, options);
        }
export type CompanyListingQueryHookResult = ReturnType<typeof useCompanyListingQuery>;
export type CompanyListingLazyQueryHookResult = ReturnType<typeof useCompanyListingLazyQuery>;
export type CompanyListingQueryResult = Apollo.QueryResult<CompanyListingQuery, CompanyListingQueryVariables>;
export const EnquiryCategoryListingDocument = gql`
    query enquiryCategoryListing($filters: EnquiryCategoryFiltersInput, $pagination: PaginationArg, $sort: [String], $publicationState: PublicationState) {
  enquiryCategories(
    filters: $filters
    pagination: $pagination
    sort: $sort
    publicationState: $publicationState
  ) {
    data {
      id
      attributes {
        ...EnquiryCategoryDetail
      }
    }
    meta {
      ...PaginationMeta
    }
  }
}
    ${EnquiryCategoryDetailFragmentDoc}
${PaginationMetaFragmentDoc}`;

/**
 * __useEnquiryCategoryListingQuery__
 *
 * To run a query within a React component, call `useEnquiryCategoryListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnquiryCategoryListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnquiryCategoryListingQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function useEnquiryCategoryListingQuery(baseOptions?: Apollo.QueryHookOptions<EnquiryCategoryListingQuery, EnquiryCategoryListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnquiryCategoryListingQuery, EnquiryCategoryListingQueryVariables>(EnquiryCategoryListingDocument, options);
      }
export function useEnquiryCategoryListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnquiryCategoryListingQuery, EnquiryCategoryListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnquiryCategoryListingQuery, EnquiryCategoryListingQueryVariables>(EnquiryCategoryListingDocument, options);
        }
export type EnquiryCategoryListingQueryHookResult = ReturnType<typeof useEnquiryCategoryListingQuery>;
export type EnquiryCategoryListingLazyQueryHookResult = ReturnType<typeof useEnquiryCategoryListingLazyQuery>;
export type EnquiryCategoryListingQueryResult = Apollo.QueryResult<EnquiryCategoryListingQuery, EnquiryCategoryListingQueryVariables>;
export const PostListingDocument = gql`
    query postListing($filters: PostFiltersInput, $pagination: PaginationArg, $sort: [String], $publicationState: PublicationState) {
  posts(
    filters: $filters
    pagination: $pagination
    sort: $sort
    publicationState: $publicationState
  ) {
    data {
      id
      attributes {
        ...PostLessDetail
      }
    }
    meta {
      ...PaginationMeta
    }
  }
}
    ${PostLessDetailFragmentDoc}
${PaginationMetaFragmentDoc}`;

/**
 * __usePostListingQuery__
 *
 * To run a query within a React component, call `usePostListingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostListingQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function usePostListingQuery(baseOptions?: Apollo.QueryHookOptions<PostListingQuery, PostListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostListingQuery, PostListingQueryVariables>(PostListingDocument, options);
      }
export function usePostListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostListingQuery, PostListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostListingQuery, PostListingQueryVariables>(PostListingDocument, options);
        }
export type PostListingQueryHookResult = ReturnType<typeof usePostListingQuery>;
export type PostListingLazyQueryHookResult = ReturnType<typeof usePostListingLazyQuery>;
export type PostListingQueryResult = Apollo.QueryResult<PostListingQuery, PostListingQueryVariables>;
export const PostDetailDocument = gql`
    query postDetail($post_id: ID) {
  post(id: $post_id) {
    data {
      id
      attributes {
        ...PostDetail
      }
    }
  }
}
    ${PostDetailFragmentDoc}`;

/**
 * __usePostDetailQuery__
 *
 * To run a query within a React component, call `usePostDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostDetailQuery({
 *   variables: {
 *      post_id: // value for 'post_id'
 *   },
 * });
 */
export function usePostDetailQuery(baseOptions?: Apollo.QueryHookOptions<PostDetailQuery, PostDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostDetailQuery, PostDetailQueryVariables>(PostDetailDocument, options);
      }
export function usePostDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostDetailQuery, PostDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostDetailQuery, PostDetailQueryVariables>(PostDetailDocument, options);
        }
export type PostDetailQueryHookResult = ReturnType<typeof usePostDetailQuery>;
export type PostDetailLazyQueryHookResult = ReturnType<typeof usePostDetailLazyQuery>;
export type PostDetailQueryResult = Apollo.QueryResult<PostDetailQuery, PostDetailQueryVariables>;
export const PostCategoryListingDocument = gql`
    query postCategoryListing($filters: PostCategoryFiltersInput, $pagination: PaginationArg, $sort: [String], $publicationState: PublicationState) {
  postCategories(
    filters: $filters
    pagination: $pagination
    sort: $sort
    publicationState: $publicationState
  ) {
    data {
      id
      attributes {
        ...PostCategories
      }
    }
    meta {
      ...PaginationMeta
    }
  }
}
    ${PostCategoriesFragmentDoc}
${PaginationMetaFragmentDoc}`;

/**
 * __usePostCategoryListingQuery__
 *
 * To run a query within a React component, call `usePostCategoryListingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostCategoryListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostCategoryListingQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function usePostCategoryListingQuery(baseOptions?: Apollo.QueryHookOptions<PostCategoryListingQuery, PostCategoryListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostCategoryListingQuery, PostCategoryListingQueryVariables>(PostCategoryListingDocument, options);
      }
export function usePostCategoryListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostCategoryListingQuery, PostCategoryListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostCategoryListingQuery, PostCategoryListingQueryVariables>(PostCategoryListingDocument, options);
        }
export type PostCategoryListingQueryHookResult = ReturnType<typeof usePostCategoryListingQuery>;
export type PostCategoryListingLazyQueryHookResult = ReturnType<typeof usePostCategoryListingLazyQuery>;
export type PostCategoryListingQueryResult = Apollo.QueryResult<PostCategoryListingQuery, PostCategoryListingQueryVariables>;
export const PostTagListingDocument = gql`
    query postTagListing($filters: PostTagFiltersInput, $pagination: PaginationArg, $sort: [String], $publicationState: PublicationState) {
  postTags(
    filters: $filters
    pagination: $pagination
    sort: $sort
    publicationState: $publicationState
  ) {
    data {
      id
      attributes {
        ...PostTags
      }
    }
    meta {
      ...PaginationMeta
    }
  }
}
    ${PostTagsFragmentDoc}
${PaginationMetaFragmentDoc}`;

/**
 * __usePostTagListingQuery__
 *
 * To run a query within a React component, call `usePostTagListingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostTagListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostTagListingQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function usePostTagListingQuery(baseOptions?: Apollo.QueryHookOptions<PostTagListingQuery, PostTagListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostTagListingQuery, PostTagListingQueryVariables>(PostTagListingDocument, options);
      }
export function usePostTagListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostTagListingQuery, PostTagListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostTagListingQuery, PostTagListingQueryVariables>(PostTagListingDocument, options);
        }
export type PostTagListingQueryHookResult = ReturnType<typeof usePostTagListingQuery>;
export type PostTagListingLazyQueryHookResult = ReturnType<typeof usePostTagListingLazyQuery>;
export type PostTagListingQueryResult = Apollo.QueryResult<PostTagListingQuery, PostTagListingQueryVariables>;